import { CartActiveFeatures } from "@/apps/merchant3/types/CartActiveFeatures";
import { computed, ComputedRef } from "vue";
import { useStore } from "vuex";

export const isCheckoutOnCreditLine: ComputedRef<boolean> = computed(() => {
  const store = useStore();

  return (
    store.getters["carts/hasActiveFeature"](
      CartActiveFeatures.CHECKOUT_ON_EXISTING_CREDIT_LINE
    ) ||
    store.getters["carts/hasActiveFeature"](
      CartActiveFeatures.CHECKOUT_ON_NEW_CREDIT_LINE
    )
  );
});

export const isCheckoutOnSubscriptionModel: ComputedRef<boolean> = computed(
  () => {
    const store = useStore();

    return store.getters["carts/hasActiveFeature"](
      CartActiveFeatures.SUBSCRIPTION_MODEL
    );
  }
);
